import { useAtomValue, useSetAtom } from 'jotai';

import {
  addressConfirmDialogOpenAtom,
  addressLookupInProgressAtom,
  selectedAddressAtom,
  nmiResolutionStateAtom,
  originAddressesAtom,
  selectedEnergyAtom,
  unconfirmedAddressAtom,
  addressEntryDedicatedNmiSearchDialogOpenAtom,
  addressManualDialogWithTabAtom,
} from './atoms';

export const useEnergyAddressLookup = () => {
  const addresses = useAtomValue(originAddressesAtom);
  const selectedAddress = useAtomValue(selectedAddressAtom);
  const unconfirmedAddress = useAtomValue(unconfirmedAddressAtom);
  const nmiResolutionState = useAtomValue(nmiResolutionStateAtom);
  const setSelectedEnergy = useSetAtom(selectedEnergyAtom);
  const isAddressLookupInProgress = useAtomValue(addressLookupInProgressAtom);
  const openConfirmAddressDialog = useSetAtom(addressConfirmDialogOpenAtom);
  const openDedicatedNmiSearchDialog = useSetAtom(addressEntryDedicatedNmiSearchDialogOpenAtom);
  const openManualAddressDialogWithTab = useSetAtom(addressManualDialogWithTabAtom);

  return {
    addresses,
    selectedAddress,
    unconfirmedAddress,
    nmiResolutionState,
    setSelectedEnergy,
    isAddressLookupInProgress,
    triggerConfirmAddressDialog: () => openConfirmAddressDialog(true),
    triggerOpenDedicatedNmiSearchDialog: () => openDedicatedNmiSearchDialog(true),
    triggerManualAddressDialogWithTab: (tabIndex: number) =>
      openManualAddressDialogWithTab(true, tabIndex),
  };
};
